import { apiCallPost } from "../api";
import { apiPaths } from "../config/apiPaths";

export const sendEmailApi = async (payload = {}, authHeaders = {}, params = {}) => {
  try {

    const { templateId, ...emailPayload } = payload;
    
    const body = {
      apiVerb: 'SEND_CUSTOM_EMAIL',
      ...emailPayload,
    };
    const res = await apiCallPost(apiPaths.email, body, authHeaders);
    if (res && Array.isArray(res) && res.length > 0 && res[0].status === 'success') {
      return { data: res[0], status: true, msg: `Email sent successfully. Request ID: ${res[0].requestId}` };
    }
    return { data: {}, status: false, errMsg: 'Failed to send email' };
  } catch (err) {
    return { status: false, errMsg: err.message || 'Failed to send email' };
  }
};
